import store from '@/store';

const redirect = (url) => {
  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        type: 'url',
        url,
      }),
    );
  } else {
    window.location.href = url;
  }
};

const openPaymentWidget = async (widgetData) => {
  const { service, paymentObject } = widgetData;
  await store.dispatch('scriptLoader/loadScript', service);

  switch (service) {
    case 'cloudpayments': {
      const language = store.getters.lang === 'ru' ? 'ru-RU' : 'en-US';
      const widget = new window.cp.CloudPayments({ language });
      widget.pay('charge', paymentObject);
      break;
    }
    case 'tiptoppay': {
      const language = store.getters.lang === 'ru' ? 'ru-RU' : 'en-US';
      const widget = new window.tiptop.Widget({ language });
      widget.pay('charge', paymentObject);
      break;
    }
    default:
      break;
  }
};

/**
 * Запускает процесс оплаты. Выполняет необходимое дествие.
 * @param data.paymentProcessType - Действие для перехода к оплате.
 * @param data.directUrl - Url для редиректа.
 * @param data.widgetData - Данные для открытия виджета.
 */
export const initPaymentProcess = async (data = {}) => {
  const {
    paymentProcessType,
    directUrl: redirectUrl,
    widgetData,
  } = data;

  if (paymentProcessType === 'redirect' && redirectUrl) {
    redirect(redirectUrl);
  }
  if (paymentProcessType === 'widget' && widgetData) {
    await openPaymentWidget(widgetData);
  }
};
